import styles from './FJTextToVideoFooter.module.less';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const FJTextToVideoFooter = props => {
    const { children, className } = props;
    return <div className={classNames(styles.container, className)}>{children}</div>;
};

FJTextToVideoFooter.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default FJTextToVideoFooter;
